import { Observable, of } from "rxjs";
import * as Graph from "src/app/services/api/savings-and-pension-queries.types";
import { Nullable } from "src/app/utils/utils";
import { ALLOWED_KRON_CONTRACT_ACCOUNT_TYPES, PensionGroup } from "../../../constants/business.constants";
import { EngagementName } from "../../pension.model";
import { SavingsAndPensionEngagement } from "./savings-and-pension-engagement.model";

type Contract = Graph.KronContract;

export abstract class AbstractKronEngagement extends SavingsAndPensionEngagement<Contract> {
  /** @deprecated Use getNameAsync instead */
  public getName(): EngagementName {
    return { name: this.contract.label ?? "" };
  }

  public getNameAsync(): Observable<EngagementName> {
    return of({ name: this.contract.label ?? "", supplier: PensionGroup.Kron });
  }

  public getContractNumberCustomer(): Nullable<string> {
    return undefined;
  }

  public getContractNumber(): Nullable<string> {
    return undefined;
  }

  public getBalance(): Nullable<number> {
    return this.contract?.marketValue ?? null;
  }

  public getTotalReturn(): undefined {
    return undefined;
  }

  public isSavingsEngagement(): boolean {
    return this.contract.accountType === Graph.KronAccountType.IpsDiscretionaryManagement;
  }

  public isActive(): boolean {
    return false;
  }

  public override getAllocationCode(): Nullable<string> {
    return undefined;
  }
}

export function isAllowedKronContractAccountType(contract: any): boolean {
  return ALLOWED_KRON_CONTRACT_ACCOUNT_TYPES.includes(contract.contract?.accountType ?? "");
}

export function getKronContractProductType(contract: any): Nullable<string> {
  const accountType: string = contract.contract?.accountType ?? "";

  switch (accountType) {
    case Graph.KronAccountType.IpsDiscretionaryManagement:
      return "sharedProductNames.kron.ips_discretionary_management";
    case Graph.KronAccountType.EpksDiscretionaryManagement:
      return "sharedProductNames.kron.epks_discretionary_management";
    case Graph.KronAccountType.PkbDiscretionaryManagement:
      return "sharedProductNames.kron.pkb_discretionary_management";
    default:
      return undefined;
  }
}

export class KronEngagement extends AbstractKronEngagement {}
